var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"titleBox"},[_c('div',{staticClass:"title_content"},[_c('div',{staticClass:"blurBox"}),_vm._v(" "+_vm._s(_vm.title)+" "),_c('span',[_vm._v(_vm._s(_vm.tip))])])])}
var staticRenderFns = []

export { render, staticRenderFns }